// Calendar editions use Shanghai civil dates. Weekdays follow Monday–Friday;
// this is an atmosphere calendar, not a statutory holiday/workday calendar.
const editions = [
 ['workday','工作日版','把想法，变成下一步。','grid','#597cca','#d4dff5','#35599a'],
 ['weekend','节假日版','今天，留一点时间给好奇心。','sun','#78a69a','#d9e9d8','#457b70'],
 ['newyear','元旦','新的一年，从一个好问题开始。','spark','#6e9ed0','#deedf5','#4975a6'],
 ['eve','除夕','岁末灯火，照亮新的期待。','lantern','#c96859','#f1cc9c','#994b43'],
 ['spring','春节','新岁有新意，好奇常相伴。','lantern','#cc594d','#f3c989','#983f38'],
 ['lantern','元宵节','灯火可亲，问题也有回响。','lantern','#d48452','#f4dfad','#a35a39'],
 ['dragonhead','龙抬头','抬头见新意，万事有开端。','dragon','#77a47e','#e1e9b0','#45775c'],
 ['qingming','清明','春风有信，草木有新。','leaf','#84a18c','#e0e7cf','#557563'],
 ['dragonboat','端午节','粽叶有清香，思路有新章。','leaf','#65947c','#d9e5b9','#396e55'],
 ['qixi','七夕','星河很远，心意很近。','heart','#a28bbd','#eadcf1','#77628e'],
 ['ghost','中元节','一盏微光，寄一份思念。','lantern','#a78a70','#ebdbb6','#7e6653'],
 ['midautumn','中秋节','月色正好，好奇心也圆满。','moon','#b89957','#f2e3b4','#88713f'],
 ['double9','重阳节','向高处走，也向温暖处靠近。','mountain','#b4986c','#ece0ba','#837247'],
 ['laba','腊八节','一碗暖意，等一个新年。','bowl','#b68770','#edd9b4','#8c6052'],
 ['valentine','情人节','让每一个认真表达，都有回应。','heart','#c58c9d','#f2dce4','#9c6179'],
 ['women','妇女节','每一种可能，都值得被看见。','flower','#ad91b7','#eddef0','#80668c'],
 ['labor','劳动节','每一份创造，都值得好好庆祝。','spark','#6f9cb3','#dbeaf0','#49788e'],
 ['children','儿童节','把世界，问成十万个为什么。','sun','#c9a268','#f6e4b2','#9b7948'],
 ['national','国庆节','山河锦绣，一起发现更多。','star','#c76557','#efd5a0','#984a41'],
 ['halloween','万圣节','今晚，给好奇心一点小惊喜。','pumpkin','#bd905b','#ecd7ae','#8c6845'],
 ['winter','冬至','白昼渐长，暖意也在生长。','bowl','#9d9783','#e8e3cc','#77735f'],
 ['teacher','教师节','每一份启发，都值得被记住。','flower','#8c9e9c','#e0e8df','#637977'],
 ['april','愚人节','认真好奇，也可以有点调皮。','spark','#bd9e8b','#f0e4d1','#907365'],
 ['christmas','圣诞节','给冬日留一份温暖与惊喜。','tree','#709589','#dce6d2','#466c5e']
].map(([id,label,subtitle,motif,face,top,side])=>({id,label,subtitle,motif,face,top,side}));
const byId = Object.fromEntries(editions.map(e=>[e.id,e]));
function civil(date) {
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Shanghai',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(date);
 const get=key=>Number(parts.find(p=>p.type===key).value);
 return {year:get('year'),month:get('month'),day:get('day')};
}
function lunar(date) { return require('./ai-lunar.cjs').lunarCivil(civil(date)); }
function solarTermDay(year, minutes) {
 // Standard mean solar-term approximation, scoped to the modern UI calendar.
 return new Date(Date.UTC(1900,0,6,2,5)+31556925974.7*(year-1900)+minutes*60000).getUTCDate();
}
function editionFor(date=new Date(), override='auto') {
 if(byId[override]) return byId[override];
 const {year,month,day}=civil(date), l=lunar(date);
 const tomorrow=lunar(new Date(date.getTime()+86400000));
 let id;
 if(l?.month===12 && tomorrow?.month===1 && tomorrow?.day===1) id='eve';
 const lunarDays={'1-1':'spring','1-2':'spring','1-3':'spring','1-15':'lantern','2-2':'dragonhead','5-5':'dragonboat','7-7':'qixi','7-15':'ghost','8-15':'midautumn','9-9':'double9','12-8':'laba'};
 id=id||lunarDays[l?.month+'-'+l?.day];
 const solar={'1-1':'newyear','2-14':'valentine','3-8':'women','4-1':'april','9-10':'teacher','5-1':'labor','6-1':'children','10-1':'national','10-2':'national','10-3':'national','10-31':'halloween','12-24':'christmas','12-25':'christmas'};
 id=id||solar[month+'-'+day];
 if(!id && month===4 && day===solarTermDay(year,128867)) id='qingming';
 if(!id && month===12 && day===solarTermDay(year,504758)) id='winter';
 const weekday=new Date(Date.UTC(year,month-1,day)).getUTCDay();
 return byId[id || (weekday===0||weekday===6?'weekend':'workday')];
}
module.exports={editions,editionFor,civil,lunar};
